var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg253(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 881.146,
    height: 802.559,
    viewBox: "0 0 881.146 802.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_253",
    "data-name": "Grupo 253",
    transform: "translate(872.659 8.487) rotate(90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8815",
    "data-name": "Ret\\xE2ngulo 8815",
    width: 78.588,
    height: 78.588,
    transform: "translate(-0.15 -0.15)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_132",
    "data-name": "Elipse 132",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(-8.487 -8.487)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8816",
    "data-name": "Ret\\xE2ngulo 8816",
    width: 78.588,
    height: 78.588,
    transform: "translate(78.439 -0.15)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_133",
    "data-name": "Elipse 133",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(70.102 -8.487)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8817",
    "data-name": "Ret\\xE2ngulo 8817",
    width: 78.588,
    height: 78.588,
    transform: "translate(157.027 -0.15)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_134",
    "data-name": "Elipse 134",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(148.69 -8.487)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8818",
    "data-name": "Ret\\xE2ngulo 8818",
    width: 78.588,
    height: 78.588,
    transform: "translate(235.615 -0.15)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_135",
    "data-name": "Elipse 135",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(227.278 -8.487)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8819",
    "data-name": "Ret\\xE2ngulo 8819",
    width: 78.588,
    height: 78.588,
    transform: "translate(314.204 -0.15)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_136",
    "data-name": "Elipse 136",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(305.867 -8.487)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8820",
    "data-name": "Ret\\xE2ngulo 8820",
    width: 78.588,
    height: 78.588,
    transform: "translate(392.792 -0.15)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_137",
    "data-name": "Elipse 137",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(384.455 -8.487)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8821",
    "data-name": "Ret\\xE2ngulo 8821",
    width: 78.588,
    height: 78.588,
    transform: "translate(471.381 -0.15)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_138",
    "data-name": "Elipse 138",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(463.044 -8.487)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8822",
    "data-name": "Ret\\xE2ngulo 8822",
    width: 78.588,
    height: 78.588,
    transform: "translate(549.969 -0.15)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_139",
    "data-name": "Elipse 139",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(541.632 -8.487)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8823",
    "data-name": "Ret\\xE2ngulo 8823",
    width: 78.588,
    height: 78.588,
    transform: "translate(628.557 -0.15)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_140",
    "data-name": "Elipse 140",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(620.22 -8.487)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8824",
    "data-name": "Ret\\xE2ngulo 8824",
    width: 78.588,
    height: 78.588,
    transform: "translate(707.146 -0.15)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_141",
    "data-name": "Elipse 141",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(698.809 -8.487)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_142",
    "data-name": "Elipse 142",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(777.397 -8.487)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8826",
    "data-name": "Ret\\xE2ngulo 8826",
    width: 78.588,
    height: 78.588,
    transform: "translate(-0.15 78.439)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_143",
    "data-name": "Elipse 143",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(-8.487 70.102)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8827",
    "data-name": "Ret\\xE2ngulo 8827",
    width: 78.588,
    height: 78.588,
    transform: "translate(78.439 78.439)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_144",
    "data-name": "Elipse 144",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(70.102 70.102)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8828",
    "data-name": "Ret\\xE2ngulo 8828",
    width: 78.588,
    height: 78.588,
    transform: "translate(157.027 78.439)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_145",
    "data-name": "Elipse 145",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(148.69 70.102)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8829",
    "data-name": "Ret\\xE2ngulo 8829",
    width: 78.588,
    height: 78.588,
    transform: "translate(235.615 78.439)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_146",
    "data-name": "Elipse 146",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(227.278 70.102)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8830",
    "data-name": "Ret\\xE2ngulo 8830",
    width: 78.588,
    height: 78.588,
    transform: "translate(314.204 78.439)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_147",
    "data-name": "Elipse 147",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(305.867 70.102)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8831",
    "data-name": "Ret\\xE2ngulo 8831",
    width: 78.588,
    height: 78.588,
    transform: "translate(392.792 78.439)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_148",
    "data-name": "Elipse 148",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(384.455 70.102)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8832",
    "data-name": "Ret\\xE2ngulo 8832",
    width: 78.588,
    height: 78.588,
    transform: "translate(471.381 78.439)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_149",
    "data-name": "Elipse 149",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(463.044 70.102)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8833",
    "data-name": "Ret\\xE2ngulo 8833",
    width: 78.588,
    height: 78.588,
    transform: "translate(549.969 78.439)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_150",
    "data-name": "Elipse 150",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(541.632 70.102)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8834",
    "data-name": "Ret\\xE2ngulo 8834",
    width: 78.588,
    height: 78.588,
    transform: "translate(628.557 78.439)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_151",
    "data-name": "Elipse 151",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(620.22 70.102)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8835",
    "data-name": "Ret\\xE2ngulo 8835",
    width: 78.588,
    height: 78.588,
    transform: "translate(707.146 78.439)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_152",
    "data-name": "Elipse 152",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(698.809 70.102)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_153",
    "data-name": "Elipse 153",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(777.397 70.102)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8837",
    "data-name": "Ret\\xE2ngulo 8837",
    width: 78.588,
    height: 78.588,
    transform: "translate(-0.15 157.027)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_154",
    "data-name": "Elipse 154",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(-8.487 148.69)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8838",
    "data-name": "Ret\\xE2ngulo 8838",
    width: 78.588,
    height: 78.588,
    transform: "translate(78.439 157.027)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_155",
    "data-name": "Elipse 155",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(70.102 148.69)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8839",
    "data-name": "Ret\\xE2ngulo 8839",
    width: 78.588,
    height: 78.588,
    transform: "translate(157.027 157.027)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_156",
    "data-name": "Elipse 156",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(148.69 148.69)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8840",
    "data-name": "Ret\\xE2ngulo 8840",
    width: 78.588,
    height: 78.588,
    transform: "translate(235.615 157.027)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_157",
    "data-name": "Elipse 157",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(227.278 148.69)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8841",
    "data-name": "Ret\\xE2ngulo 8841",
    width: 78.588,
    height: 78.588,
    transform: "translate(314.204 157.027)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_158",
    "data-name": "Elipse 158",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(305.867 148.69)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8842",
    "data-name": "Ret\\xE2ngulo 8842",
    width: 78.588,
    height: 78.588,
    transform: "translate(392.792 157.027)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_159",
    "data-name": "Elipse 159",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(384.455 148.69)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8843",
    "data-name": "Ret\\xE2ngulo 8843",
    width: 78.588,
    height: 78.588,
    transform: "translate(471.381 157.027)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_160",
    "data-name": "Elipse 160",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(463.044 148.69)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8844",
    "data-name": "Ret\\xE2ngulo 8844",
    width: 78.588,
    height: 78.588,
    transform: "translate(549.969 157.027)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_161",
    "data-name": "Elipse 161",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(541.632 148.69)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8845",
    "data-name": "Ret\\xE2ngulo 8845",
    width: 78.588,
    height: 78.588,
    transform: "translate(628.557 157.027)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_162",
    "data-name": "Elipse 162",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(620.22 148.69)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8846",
    "data-name": "Ret\\xE2ngulo 8846",
    width: 78.588,
    height: 78.588,
    transform: "translate(707.146 157.027)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_163",
    "data-name": "Elipse 163",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(698.809 148.69)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_164",
    "data-name": "Elipse 164",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(777.397 148.69)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8848",
    "data-name": "Ret\\xE2ngulo 8848",
    width: 78.588,
    height: 78.588,
    transform: "translate(-0.15 235.615)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_165",
    "data-name": "Elipse 165",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(-8.487 227.278)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8849",
    "data-name": "Ret\\xE2ngulo 8849",
    width: 78.588,
    height: 78.588,
    transform: "translate(78.439 235.615)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_166",
    "data-name": "Elipse 166",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(70.102 227.278)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8850",
    "data-name": "Ret\\xE2ngulo 8850",
    width: 78.588,
    height: 78.588,
    transform: "translate(157.027 235.615)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_167",
    "data-name": "Elipse 167",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(148.69 227.278)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8851",
    "data-name": "Ret\\xE2ngulo 8851",
    width: 78.588,
    height: 78.588,
    transform: "translate(235.615 235.615)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_168",
    "data-name": "Elipse 168",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(227.278 227.278)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8852",
    "data-name": "Ret\\xE2ngulo 8852",
    width: 78.588,
    height: 78.588,
    transform: "translate(314.204 235.615)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_169",
    "data-name": "Elipse 169",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(305.867 227.278)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8853",
    "data-name": "Ret\\xE2ngulo 8853",
    width: 78.588,
    height: 78.588,
    transform: "translate(392.792 235.615)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_170",
    "data-name": "Elipse 170",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(384.455 227.278)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8854",
    "data-name": "Ret\\xE2ngulo 8854",
    width: 78.588,
    height: 78.588,
    transform: "translate(471.381 235.615)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_171",
    "data-name": "Elipse 171",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(463.044 227.278)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8855",
    "data-name": "Ret\\xE2ngulo 8855",
    width: 78.588,
    height: 78.588,
    transform: "translate(549.969 235.615)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_172",
    "data-name": "Elipse 172",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(541.632 227.278)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8856",
    "data-name": "Ret\\xE2ngulo 8856",
    width: 78.588,
    height: 78.588,
    transform: "translate(628.557 235.615)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_173",
    "data-name": "Elipse 173",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(620.22 227.278)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8857",
    "data-name": "Ret\\xE2ngulo 8857",
    width: 78.588,
    height: 78.588,
    transform: "translate(707.146 235.615)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_174",
    "data-name": "Elipse 174",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(698.809 227.278)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_175",
    "data-name": "Elipse 175",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(777.397 227.278)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8859",
    "data-name": "Ret\\xE2ngulo 8859",
    width: 78.588,
    height: 78.588,
    transform: "translate(-0.15 314.204)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_176",
    "data-name": "Elipse 176",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(-8.487 305.867)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8860",
    "data-name": "Ret\\xE2ngulo 8860",
    width: 78.588,
    height: 78.588,
    transform: "translate(78.439 314.204)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_177",
    "data-name": "Elipse 177",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(70.102 305.867)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8861",
    "data-name": "Ret\\xE2ngulo 8861",
    width: 78.588,
    height: 78.588,
    transform: "translate(157.027 314.204)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_178",
    "data-name": "Elipse 178",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(148.69 305.867)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8862",
    "data-name": "Ret\\xE2ngulo 8862",
    width: 78.588,
    height: 78.588,
    transform: "translate(235.615 314.204)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_179",
    "data-name": "Elipse 179",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(227.278 305.867)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8863",
    "data-name": "Ret\\xE2ngulo 8863",
    width: 78.588,
    height: 78.588,
    transform: "translate(314.204 314.204)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_180",
    "data-name": "Elipse 180",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(305.867 305.867)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8864",
    "data-name": "Ret\\xE2ngulo 8864",
    width: 78.588,
    height: 78.588,
    transform: "translate(392.792 314.204)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_181",
    "data-name": "Elipse 181",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(384.455 305.867)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8865",
    "data-name": "Ret\\xE2ngulo 8865",
    width: 78.588,
    height: 78.588,
    transform: "translate(471.381 314.204)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_182",
    "data-name": "Elipse 182",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(463.044 305.867)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8866",
    "data-name": "Ret\\xE2ngulo 8866",
    width: 78.588,
    height: 78.588,
    transform: "translate(549.969 314.204)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_183",
    "data-name": "Elipse 183",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(541.632 305.867)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8867",
    "data-name": "Ret\\xE2ngulo 8867",
    width: 78.588,
    height: 78.588,
    transform: "translate(628.557 314.204)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_184",
    "data-name": "Elipse 184",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(620.22 305.867)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8868",
    "data-name": "Ret\\xE2ngulo 8868",
    width: 78.588,
    height: 78.588,
    transform: "translate(707.146 314.204)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_185",
    "data-name": "Elipse 185",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(698.809 305.867)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_186",
    "data-name": "Elipse 186",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(777.397 305.867)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8870",
    "data-name": "Ret\\xE2ngulo 8870",
    width: 78.588,
    height: 78.588,
    transform: "translate(-0.15 392.792)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_187",
    "data-name": "Elipse 187",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(-8.487 384.455)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8871",
    "data-name": "Ret\\xE2ngulo 8871",
    width: 78.588,
    height: 78.588,
    transform: "translate(78.439 392.792)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_188",
    "data-name": "Elipse 188",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(70.102 384.455)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8872",
    "data-name": "Ret\\xE2ngulo 8872",
    width: 78.588,
    height: 78.588,
    transform: "translate(157.027 392.792)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_189",
    "data-name": "Elipse 189",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(148.69 384.455)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8873",
    "data-name": "Ret\\xE2ngulo 8873",
    width: 78.588,
    height: 78.588,
    transform: "translate(235.615 392.792)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_190",
    "data-name": "Elipse 190",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(227.278 384.455)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8874",
    "data-name": "Ret\\xE2ngulo 8874",
    width: 78.588,
    height: 78.588,
    transform: "translate(314.204 392.792)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_191",
    "data-name": "Elipse 191",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(305.867 384.455)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8875",
    "data-name": "Ret\\xE2ngulo 8875",
    width: 78.588,
    height: 78.588,
    transform: "translate(392.792 392.792)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_192",
    "data-name": "Elipse 192",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(384.455 384.455)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8876",
    "data-name": "Ret\\xE2ngulo 8876",
    width: 78.588,
    height: 78.588,
    transform: "translate(471.381 392.792)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_193",
    "data-name": "Elipse 193",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(463.044 384.455)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8877",
    "data-name": "Ret\\xE2ngulo 8877",
    width: 78.588,
    height: 78.588,
    transform: "translate(549.969 392.792)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_194",
    "data-name": "Elipse 194",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(541.632 384.455)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8878",
    "data-name": "Ret\\xE2ngulo 8878",
    width: 78.588,
    height: 78.588,
    transform: "translate(628.557 392.792)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_195",
    "data-name": "Elipse 195",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(620.22 384.455)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8879",
    "data-name": "Ret\\xE2ngulo 8879",
    width: 78.588,
    height: 78.588,
    transform: "translate(707.146 392.792)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_196",
    "data-name": "Elipse 196",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(698.809 384.455)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_197",
    "data-name": "Elipse 197",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(777.397 384.455)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8881",
    "data-name": "Ret\\xE2ngulo 8881",
    width: 78.588,
    height: 78.588,
    transform: "translate(-0.15 471.381)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_198",
    "data-name": "Elipse 198",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(-8.487 463.044)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8882",
    "data-name": "Ret\\xE2ngulo 8882",
    width: 78.588,
    height: 78.588,
    transform: "translate(78.439 471.381)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_199",
    "data-name": "Elipse 199",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(70.102 463.044)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8883",
    "data-name": "Ret\\xE2ngulo 8883",
    width: 78.588,
    height: 78.588,
    transform: "translate(157.027 471.381)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_200",
    "data-name": "Elipse 200",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(148.69 463.044)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8884",
    "data-name": "Ret\\xE2ngulo 8884",
    width: 78.588,
    height: 78.588,
    transform: "translate(235.615 471.381)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_201",
    "data-name": "Elipse 201",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(227.278 463.044)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8885",
    "data-name": "Ret\\xE2ngulo 8885",
    width: 78.588,
    height: 78.588,
    transform: "translate(314.204 471.381)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_202",
    "data-name": "Elipse 202",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(305.867 463.044)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8886",
    "data-name": "Ret\\xE2ngulo 8886",
    width: 78.588,
    height: 78.588,
    transform: "translate(392.792 471.381)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_203",
    "data-name": "Elipse 203",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(384.455 463.044)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8887",
    "data-name": "Ret\\xE2ngulo 8887",
    width: 78.588,
    height: 78.588,
    transform: "translate(471.381 471.381)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_204",
    "data-name": "Elipse 204",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(463.044 463.044)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8888",
    "data-name": "Ret\\xE2ngulo 8888",
    width: 78.588,
    height: 78.588,
    transform: "translate(549.969 471.381)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_205",
    "data-name": "Elipse 205",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(541.632 463.044)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8889",
    "data-name": "Ret\\xE2ngulo 8889",
    width: 78.588,
    height: 78.588,
    transform: "translate(628.557 471.381)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_206",
    "data-name": "Elipse 206",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(620.22 463.044)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8890",
    "data-name": "Ret\\xE2ngulo 8890",
    width: 78.588,
    height: 78.588,
    transform: "translate(707.146 471.381)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_207",
    "data-name": "Elipse 207",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(698.809 463.044)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_208",
    "data-name": "Elipse 208",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(777.397 463.044)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8892",
    "data-name": "Ret\\xE2ngulo 8892",
    width: 78.588,
    height: 78.588,
    transform: "translate(-0.15 549.969)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_209",
    "data-name": "Elipse 209",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(-8.487 541.632)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8893",
    "data-name": "Ret\\xE2ngulo 8893",
    width: 78.588,
    height: 78.588,
    transform: "translate(78.439 549.969)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_210",
    "data-name": "Elipse 210",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(70.102 541.632)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8894",
    "data-name": "Ret\\xE2ngulo 8894",
    width: 78.588,
    height: 78.588,
    transform: "translate(157.027 549.969)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_211",
    "data-name": "Elipse 211",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(148.69 541.632)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8895",
    "data-name": "Ret\\xE2ngulo 8895",
    width: 78.588,
    height: 78.588,
    transform: "translate(235.615 549.969)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_212",
    "data-name": "Elipse 212",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(227.278 541.632)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8896",
    "data-name": "Ret\\xE2ngulo 8896",
    width: 78.588,
    height: 78.588,
    transform: "translate(314.204 549.969)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_213",
    "data-name": "Elipse 213",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(305.867 541.632)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8897",
    "data-name": "Ret\\xE2ngulo 8897",
    width: 78.588,
    height: 78.588,
    transform: "translate(392.792 549.969)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_214",
    "data-name": "Elipse 214",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(384.455 541.632)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8898",
    "data-name": "Ret\\xE2ngulo 8898",
    width: 78.588,
    height: 78.588,
    transform: "translate(471.381 549.969)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_215",
    "data-name": "Elipse 215",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(463.044 541.632)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8899",
    "data-name": "Ret\\xE2ngulo 8899",
    width: 78.588,
    height: 78.588,
    transform: "translate(549.969 549.969)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_216",
    "data-name": "Elipse 216",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(541.632 541.632)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8900",
    "data-name": "Ret\\xE2ngulo 8900",
    width: 78.588,
    height: 78.588,
    transform: "translate(628.557 549.969)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_217",
    "data-name": "Elipse 217",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(620.22 541.632)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8901",
    "data-name": "Ret\\xE2ngulo 8901",
    width: 78.588,
    height: 78.588,
    transform: "translate(707.146 549.969)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_218",
    "data-name": "Elipse 218",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(698.809 541.632)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_219",
    "data-name": "Elipse 219",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(777.397 541.632)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8903",
    "data-name": "Ret\\xE2ngulo 8903",
    width: 78.588,
    height: 78.588,
    transform: "translate(-0.15 628.557)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_220",
    "data-name": "Elipse 220",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(-8.487 620.22)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8904",
    "data-name": "Ret\\xE2ngulo 8904",
    width: 78.588,
    height: 78.588,
    transform: "translate(78.439 628.557)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_221",
    "data-name": "Elipse 221",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(70.102 620.22)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8905",
    "data-name": "Ret\\xE2ngulo 8905",
    width: 78.588,
    height: 78.588,
    transform: "translate(157.027 628.557)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_222",
    "data-name": "Elipse 222",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(148.69 620.22)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8906",
    "data-name": "Ret\\xE2ngulo 8906",
    width: 78.588,
    height: 78.588,
    transform: "translate(235.615 628.557)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_223",
    "data-name": "Elipse 223",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(227.278 620.22)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8907",
    "data-name": "Ret\\xE2ngulo 8907",
    width: 78.588,
    height: 78.588,
    transform: "translate(314.204 628.557)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_224",
    "data-name": "Elipse 224",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(305.867 620.22)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8908",
    "data-name": "Ret\\xE2ngulo 8908",
    width: 78.588,
    height: 78.588,
    transform: "translate(392.792 628.557)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_225",
    "data-name": "Elipse 225",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(384.455 620.22)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8909",
    "data-name": "Ret\\xE2ngulo 8909",
    width: 78.588,
    height: 78.588,
    transform: "translate(471.381 628.557)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_226",
    "data-name": "Elipse 226",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(463.044 620.22)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8910",
    "data-name": "Ret\\xE2ngulo 8910",
    width: 78.588,
    height: 78.588,
    transform: "translate(549.969 628.557)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_227",
    "data-name": "Elipse 227",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(541.632 620.22)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8911",
    "data-name": "Ret\\xE2ngulo 8911",
    width: 78.588,
    height: 78.588,
    transform: "translate(628.557 628.557)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_228",
    "data-name": "Elipse 228",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(620.22 620.22)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8912",
    "data-name": "Ret\\xE2ngulo 8912",
    width: 78.588,
    height: 78.588,
    transform: "translate(707.146 628.557)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_229",
    "data-name": "Elipse 229",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(698.809 620.22)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_230",
    "data-name": "Elipse 230",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(777.397 620.22)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8914",
    "data-name": "Ret\\xE2ngulo 8914",
    width: 78.588,
    height: 78.588,
    transform: "translate(-0.15 707.146)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_231",
    "data-name": "Elipse 231",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(-8.487 698.809)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8915",
    "data-name": "Ret\\xE2ngulo 8915",
    width: 78.588,
    height: 78.588,
    transform: "translate(78.439 707.146)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_232",
    "data-name": "Elipse 232",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(70.102 698.809)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8916",
    "data-name": "Ret\\xE2ngulo 8916",
    width: 78.588,
    height: 78.588,
    transform: "translate(157.027 707.146)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_233",
    "data-name": "Elipse 233",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(148.69 698.809)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8917",
    "data-name": "Ret\\xE2ngulo 8917",
    width: 78.588,
    height: 78.588,
    transform: "translate(235.615 707.146)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_234",
    "data-name": "Elipse 234",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(227.278 698.809)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8918",
    "data-name": "Ret\\xE2ngulo 8918",
    width: 78.588,
    height: 78.588,
    transform: "translate(314.204 707.146)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_235",
    "data-name": "Elipse 235",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(305.867 698.809)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8919",
    "data-name": "Ret\\xE2ngulo 8919",
    width: 78.588,
    height: 78.588,
    transform: "translate(392.792 707.146)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_236",
    "data-name": "Elipse 236",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(384.455 698.809)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8920",
    "data-name": "Ret\\xE2ngulo 8920",
    width: 78.588,
    height: 78.588,
    transform: "translate(471.381 707.146)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_237",
    "data-name": "Elipse 237",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(463.044 698.809)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8921",
    "data-name": "Ret\\xE2ngulo 8921",
    width: 78.588,
    height: 78.588,
    transform: "translate(549.969 707.146)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_238",
    "data-name": "Elipse 238",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(541.632 698.809)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8922",
    "data-name": "Ret\\xE2ngulo 8922",
    width: 78.588,
    height: 78.588,
    transform: "translate(628.557 707.146)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_239",
    "data-name": "Elipse 239",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(620.22 698.809)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8923",
    "data-name": "Ret\\xE2ngulo 8923",
    width: 78.588,
    height: 78.588,
    transform: "translate(707.146 707.146)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_240",
    "data-name": "Elipse 240",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(698.809 698.809)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_241",
    "data-name": "Elipse 241",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(777.397 698.809)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8925",
    "data-name": "Ret\\xE2ngulo 8925",
    width: 78.588,
    height: 78.588,
    transform: "translate(-0.15 785.734)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_242",
    "data-name": "Elipse 242",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(-8.487 777.397)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_376",
    "data-name": "Elipse 376",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(-8.487 855.985)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8926",
    "data-name": "Ret\\xE2ngulo 8926",
    width: 78.588,
    height: 78.588,
    transform: "translate(78.439 785.734)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_243",
    "data-name": "Elipse 243",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(70.102 777.397)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_375",
    "data-name": "Elipse 375",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(70.102 855.985)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8927",
    "data-name": "Ret\\xE2ngulo 8927",
    width: 78.588,
    height: 78.588,
    transform: "translate(157.027 785.734)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_244",
    "data-name": "Elipse 244",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(148.69 777.397)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_377",
    "data-name": "Elipse 377",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(148.69 855.985)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8928",
    "data-name": "Ret\\xE2ngulo 8928",
    width: 78.588,
    height: 78.588,
    transform: "translate(235.615 785.734)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_245",
    "data-name": "Elipse 245",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(227.278 777.397)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_378",
    "data-name": "Elipse 378",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(227.278 855.985)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8929",
    "data-name": "Ret\\xE2ngulo 8929",
    width: 78.588,
    height: 78.588,
    transform: "translate(314.204 785.734)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_246",
    "data-name": "Elipse 246",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(305.867 777.397)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_379",
    "data-name": "Elipse 379",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(305.867 855.985)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8930",
    "data-name": "Ret\\xE2ngulo 8930",
    width: 78.588,
    height: 78.588,
    transform: "translate(392.792 785.734)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_247",
    "data-name": "Elipse 247",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(384.455 777.397)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_380",
    "data-name": "Elipse 380",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(384.455 855.985)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8931",
    "data-name": "Ret\\xE2ngulo 8931",
    width: 78.588,
    height: 78.588,
    transform: "translate(471.381 785.734)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_248",
    "data-name": "Elipse 248",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(463.044 777.397)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_381",
    "data-name": "Elipse 381",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(463.044 855.985)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8932",
    "data-name": "Ret\\xE2ngulo 8932",
    width: 78.588,
    height: 78.588,
    transform: "translate(549.969 785.734)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_249",
    "data-name": "Elipse 249",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(541.632 777.397)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_382",
    "data-name": "Elipse 382",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(541.632 855.985)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8933",
    "data-name": "Ret\\xE2ngulo 8933",
    width: 78.588,
    height: 78.588,
    transform: "translate(628.557 785.734)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_250",
    "data-name": "Elipse 250",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(620.22 777.397)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_383",
    "data-name": "Elipse 383",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(620.22 855.985)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8934",
    "data-name": "Ret\\xE2ngulo 8934",
    width: 78.588,
    height: 78.588,
    transform: "translate(707.146 785.734)",
    fill: "none",
    stroke: "#0092f6",
    strokeWidth: 2.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_251",
    "data-name": "Elipse 251",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(698.809 777.397)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_384",
    "data-name": "Elipse 384",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(698.809 855.985)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_252",
    "data-name": "Elipse 252",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(777.397 777.397)",
    fill: "#0092f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_385",
    "data-name": "Elipse 385",
    cx: 8.337,
    cy: 8.337,
    r: 8.337,
    transform: "translate(777.397 855.985)",
    fill: "#0092f6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg253);
export default __webpack_public_path__ + "static/media/253.f9d6b52cc302b15c604f6d297227978a.svg";
export { ForwardRef as ReactComponent };